/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Login
 * @export
 * @interface CompanyLogin
 */
export interface CompanyLogin {
    /**
     * 
     * @type {string}
     * @memberof CompanyLogin
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyLogin
     */
    password?: string;
}

export function CompanyLoginFromJSON(json: any): CompanyLogin {
    return CompanyLoginFromJSONTyped(json, false);
}

export function CompanyLoginFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyLogin {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': !exists(json, 'email') ? undefined : json['email'],
        'password': !exists(json, 'password') ? undefined : json['password'],
    };
}

export function CompanyLoginToJSON(value?: CompanyLogin | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'password': value.password,
    };
}


